import React from "react";
import { LoaderBloc } from '../assets/styles/components/globalStyle';

export default function Loader({ transparent = true, size }) {
  const getsize = () => {
    switch (size) {
      case "":
        return "";
      case "md":
        return "md";
      case "xs":
        return "xs";
      default:
        return "";
    }
  };
  return (
    <LoaderBloc
      className={`full-spinner ${
        !transparent ? "background-load" : ""
      } ${getsize()}`}
    >
      <div className="loadingio-spinner-ripple">
        <div className="ldio">
          <div></div>
          <div></div>
        </div>
      </div>
    </LoaderBloc>
  );
}
